<template>
  <div class="filter__item__body">
    <i-select :value="value" :filterable="true" @input="update">
      <i-option
        v-for="option in options"
        :key="option.id"
        :label="option.name"
        :value="option.id"
      />
    </i-select>
  </div>
</template>

<script>
  export default {
    props: {
      options: {
        type: Array,
        default: () => []
      },
      value: {
        type: Number,
        default: null
      }
    },

    methods: {
      update(e) {
        this.$emit('input', e);
      }
    }
  };
</script>
